import {
  
    Button,
    PlusIcon,

} from "melco-ui";
import { useTranslation } from "react-i18next";

import { Drawer as DrawerType } from "../../hooks/drawer/useGenericDrawer";
import { useFormikContext } from "formik";



type GenerateLicenseConfirmButtonProps = {
    GenerateConfirmDetailsToDisplay: any;
    referencesDrawer?: DrawerType;
    openAskConirmationBoxTrigger?: boolean;
    onCloseDrawer?: (closeDrawer: boolean) => void;
    GenerateConfirmDetails: any;
};

export const GenerateLicenseConfirmButton: React.FC<
    GenerateLicenseConfirmButtonProps
> = ({  }) => {

    const { t } = useTranslation();
   
    const { submitForm, } = useFormikContext();

   


    return (

        <>
            <Button
                icon={<PlusIcon />}
                type="primary"

                onClick={() => {

                   submitForm();
                }}
            >
                {t("licenses.basic.detail.generate.serial_number.button")}
            </Button></>
    );
};
